import Context from "../data/Context";

export default class ContextAccess {
  static TAG = "Triskele Context";

  static get = (tag = ContextAccess.TAG) => {
    return new Promise((resolve, reject) => {
      resolve(new Context());
    });
  };

  static save = (context, tag = ContextAccess.TAG) => {
    return new Promise((resolve, reject) => {
      resolve(new Context());
    });
  };
}